<script lang="ts" setup>
import type { ApiCustomerModuleDefectGetAll } from '~/layers/customer-module/types'

const props = defineProps<{
  payload: ApiCustomerModuleDefectGetAll
}>()
const emit = defineEmits<{ (e: 'close'): void }>()
</script>

<template>
  <CustomerModulePopup
    show
    :title="$t('customerModule.defect.detailsPopUp.title', { machineryId: props.payload.machineryId })"
    @close="emit('close')"
  >
    <CustomerModuleListItem
      :label="$t('customerModule.defect.detailsPopUp.description.label')"
      :value="payload.description"
      size="md"
    />

    <CustomerModuleListItem
      v-if="payload.alternativeContactPersonName"
      :label="$t('scustomerModule.defect.detailsPopUp.alternativeContactPersonName.label')"
      :value="payload.alternativeContactPersonName"
      size="md"
    />

    <CustomerModuleListItem
      v-if="payload.alternativeContactPersonPhone"
      :label="$t('customerModule.defect.detailsPopUp.alternativeContactPersonPhone.label')"
      :value="payload.alternativeContactPersonPhone"
      size="md"
    />

    <FileView
      v-if="payload.photos && payload.photos.length > 0"
      :label="$t('customerModule.defect.detailsPopUp.photos.label')"
      :files="payload.photos"
    />
  </CustomerModulePopup>
</template>
